(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-buy-box"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(cents, fmt) {
    var amount = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    var out = (fmt || ('$' + '{' + '{amount}' + '}'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
    var el = document.createElement('textarea');
    el.innerHTML = out;
    return el.value;
  }
  document.querySelectorAll('[data-kr-bb]').forEach(function (root) {
    var fmt = root.getAttribute('data-money-format');
    var plan = 'sub';
    function q(sel) { return root.querySelector(sel); }
    function qa(sel) { return root.querySelectorAll(sel); }
    function activeCard() {
      var group = q('.kr-bb__cards.is-active');
      if (!group) return null;
      var card = group.querySelector('.kr-bb__card.is-active') || group.querySelector('.kr-bb__card');
      if (card) card.classList.add('is-active');
      return card;
    }
    function swapImage(card) {
      var gallery = q('.kr-bb__set-gallery.is-active');
      if (!gallery) return;
      var main = gallery.querySelector('[data-kr-main]');
      var mainImg = main && main.querySelector('img');
      var first = gallery.querySelector('.kr-bb__thumb');
      var src = card.dataset.image || (main && main.dataset.original) || '';
      var thumbSrc = card.dataset.thumb || (first && first.dataset.thumbOriginal) || src;
      if (mainImg && src) { mainImg.removeAttribute('srcset'); mainImg.src = src; }
      if (first) {
        first.dataset.full = card.dataset.image || first.dataset.original;
        var fi = first.querySelector('img');
        if (fi && thumbSrc) { fi.removeAttribute('srcset'); fi.src = thumbSrc; }
        gallery.querySelectorAll('.kr-bb__thumb').forEach(function (t) { t.classList.toggle('is-active', t === first); });
      }
    }
    function update() {
      var card = activeCard();
      if (!card) return;
      var price = +card.dataset.price;
      var sub = +card.dataset.subPrice;
      var hasPlan = !!card.dataset.planId;
      var subOpt = q('[data-option="sub"]');
      subOpt.hidden = !hasPlan;
      if (!hasPlan) plan = 'once';
      qa('[data-option]').forEach(function (o) {
        var on = o.dataset.option === plan;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      qa('[data-kr-sub-price]').forEach(function (e) { e.textContent = money(sub, fmt); });
      qa('[data-kr-compare]').forEach(function (e) { e.textContent = money(price, fmt); });
      qa('[data-kr-price]').forEach(function (e) { e.textContent = money(price, fmt); });
      qa('[data-kr-discount]').forEach(function (e) { e.textContent = card.dataset.discount; });
      q('[data-kr-variant]').value = card.dataset.variantId;
      var planInput = q('[data-kr-plan]');
      planInput.value = plan === 'sub' ? card.dataset.planId : '';
      planInput.disabled = plan !== 'sub';
      swapImage(card);
      var btn = q('[data-kr-submit]');
      if (!btn.dataset.label) btn.dataset.label = btn.textContent;
      var available = card.dataset.available === 'true';
      btn.disabled = !available;
      btn.textContent = available ? btn.dataset.label : 'Sold out';
    }
    var form = q('[data-kr-bb-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;
        e.preventDefault();
        var btn = q('[data-kr-submit]');
        var err = q('[data-kr-error]');
        err.hidden = true;
        btn.disabled = true;
        btn.classList.add('is-loading');
        var data = new FormData(form);
        data.append('sections', 'cart-drawer,cart-icon-bubble');
        data.append('sections_url', window.location.pathname);
        fetch(form.getAttribute('action') + '.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
          .then(function (r) {
            if (!r.ok || r.json.status) {
              err.textContent = r.json.description || r.json.message || 'Sorry, something went wrong. Please try again.';
              err.hidden = false;
              return;
            }
            drawer.classList.remove('is-empty');
            if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn);
            drawer.renderContents(r.json);
            if (typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open(btn);
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            btn.classList.remove('is-loading');
            update();
          });
      });
    }
    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-set-tab]');
      var card = e.target.closest('.kr-bb__card');
      var opt = e.target.closest('[data-option]');
      var thumb = e.target.closest('.kr-bb__thumb');
      if (tab) {
        var set = tab.dataset.setTab;
        qa('[data-set-tab]').forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        qa('.kr-bb__cards, .kr-bb__set-gallery, .kr-bb__set-info').forEach(function (g) { g.classList.toggle('is-active', g.dataset.set === set); });
        plan = 'sub';
        update();
      } else if (card) {
        card.parentNode.querySelectorAll('.kr-bb__card').forEach(function (c) { c.classList.toggle('is-active', c === card); });
        update();
      } else if (opt) {
        plan = opt.dataset.option;
        update();
      } else if (thumb) {
        var gallery = thumb.closest('.kr-bb__set-gallery');
        var main = gallery.querySelector('[data-kr-main] img');
        if (main) { main.removeAttribute('srcset'); main.src = thumb.dataset.full; }
        gallery.querySelectorAll('.kr-bb__thumb').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      }
    });
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-kr-sticky]').forEach(function (el) {
    var target = document.getElementById(el.dataset.target);
    function update() {
      var show = window.scrollY > 600;
      if (target) {
        var r = target.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) show = false;
      }
      el.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-ugc-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('click', function (e) {
    var fig = e.target.closest('[data-kr-ugc]');
    if (!fig) return;
    var video = fig.querySelector('video');
    if (!video) return;
    var turnOn = video.muted;
    document.querySelectorAll('[data-kr-ugc]').forEach(function (f) {
      var v = f.querySelector('video');
      if (v) v.muted = true;
      f.classList.remove('is-sound');
    });
    if (turnOn) {
      video.muted = false;
      video.play();
      fig.classList.add('is-sound');
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
